<template>
  <div>
    <v-navigation-drawer v-model="drawer" app class="primary">
      <v-layout column align-center>
        <v-flex class="mt-5">
          <v-avatar size="100" color="teal">
            <img
                  alt="Avatar"
                  src="../../public/logo/logo-ecole.png"
                />
          </v-avatar>
          <p class="white--text subheading mt-1" v-if="user">{{ user.name }}</p>
        </v-flex>
      </v-layout>

      <v-divider dark></v-divider>

      <v-list dense rounded>
        <v-list-item v-for="link in links" :key="link.text" router :to="link.route" exact>
          <v-list-item-action>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout()">
            {{$t("actions.logout")}}
            <v-icon right>mdi-exit-to-app</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app class="primary" dark>
      <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" />
      <v-toolbar-title class="white--text text-uppercase">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>


      <v-btn icon to="/account">
        <v-icon color="white">mdi-account</v-icon>
      </v-btn>
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">
              <v-icon>mdi-translate</v-icon>
              {{ $i18n.locale }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index" :value="item.title" @click="changeLocale(item.local)">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TheNavBar",
  data: () => ({
    drawer: null,
    links: [
      {
        icon: "mdi-view-dashboard",
        text: "Tableau de bord",
        route: "/school/1"
      },
      {
        icon: "mdi-folder",
        text: "Inscription",
        route: "/school/1/inscription"
      },
      {
        icon: "mdi-credit-card-outline",
        text: "Paiement",
        route: "/school/1/paiement"
      },
      { icon: "mdi-human-male", text: "Tuteur", route: "/school/1/tutor" },
      {
        icon: "mdi-human-male-child",
        text: "Élève",
        route: "/school/1/student"
      },
      { icon: "mdi-school", text: "Enseignant", route: "/school/1/teacher" },
      {
        icon: "mdi-google-classroom",
        text: "Classe",
        route: "/school/1/class"
      },
      { icon: "mdi-cog", text: "Configuration", route: "/school/1/settings" }
    ],
    langs: ["en", "fr"],
    items: [
      { title: "English", local: "en" },
      { title: "Français", local: "fr" }
    ]
  }),
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user"
    }),
    title(){
     return this.$t(this.$route.meta.title);
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch("logout")
        .then(() => {
          console.log("déconnection réussi");
          this.$router.push("/");
        })
        .catch(e => {
          console.log(e);
        });
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
      this.$vuetify.lang.current = locale
    }
  }
};
</script>
